import collectionService from '../../services/collections';

export default {
  state: {
    collections: [],
    constructors: [],
    tickets: [],
    themes: [],
    questions: [],
    examQuestions: [],
    examAdditionalQuestions: [],
    simulatorWrongQuestions: [],
    isLoading: {
      collections: false,
      tickets: false,
      themes: false,
      questions: false,
    },
  },
  getters: {
    collections: state => state.collections,
    collectionsExams: state => state.collections.filter(e => e.exam !== 0),
    constructors: state => state.constructors,
    tickets: state => state.tickets,
    questions: state => state.questions,
    themes: state => state.themes,
    examQuestions: state => state.examQuestions,
    collectionsLoaders: state => state.isLoading,
    simulatorWrongQuestions: state => state.simulatorWrongQuestions,
  },
  actions: {
    getCollections({ commit }, exam) {
      commit('collections_loading_start');
      return new Promise((resolve, reject) => {
        collectionService.getCollections(exam)
          .then((response) => {
            commit('set_collections', response.data);
            commit('collections_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('collections_loading_finish');
          });
      });
    },
    getConstructors({ commit }, exam) {
      commit('collections_loading_start');
      return new Promise((resolve, reject) => {
        collectionService.getConstructors(exam)
          .then((response) => {
            commit('set_constructors', response.data);
            commit('collections_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('collections_loading_finish');
          });
      });
    },
    getCollectionTickets({ commit }, id) {
      commit('tickets_loading_start');

      return new Promise((resolve, reject) => {
        collectionService.getCollectionTickets(id)
          .then((response) => {
            commit('set_collection_tickets', response.data);
            commit('tickets_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('tickets_loading_finish');
          });
      });
    },
    getCollectionThemes({ commit }, id) {
      commit('themes_loading_start');

      return new Promise((resolve, reject) => {
        collectionService.getCollectionThemes(id)
          .then((response) => {
            commit('set_themes', response.data);
            commit('themes_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('themes_loading_finish');
          });
      });
    },
    getTicketQuestions({ commit }, ticketParams) {
      commit('questions_loading_start');

      return new Promise((resolve, reject) => {
        collectionService.getTicketQuestions(ticketParams.collectionId, ticketParams.ticketId)
          .then((response) => {
            commit('set_questions', response.data);
            commit('questions_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('questions_loading_finish');
          });
      });
    },
    getThemeQuestions({ commit }, theme) {
      commit('questions_loading_start');

      return new Promise((resolve, reject) => {
        collectionService.getThemeQuestions(theme)
          .then((response) => {
            commit('set_questions', response.data);
            commit('questions_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('questions_loading_finish');
          });
      });
    },
    getExamQuestions({ commit }, data) {
      commit('questions_loading_start');

      return new Promise((resolve, reject) => {
        collectionService.getExamQuestions(data.id, data.type, data.isSimulator)
          .then((response) => {
            commit('set_questions', response.data);
            commit('questions_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('questions_loading_finish');
          });
      });
    },
    getConstructorQuestions({ commit }, data) {
      commit('questions_loading_start');

      return new Promise((resolve, reject) => {
        collectionService.getConstructorQuestions(data.id)
          .then((response) => {
            commit('set_questions', response.data);
            commit('questions_loading_finish');
            resolve();
          })
          .catch(() => {
            reject();
            commit('questions_loading_finish');
          });
      });
    },
    getExamAdditionalQuestions({ commit }, data) {
      return new Promise((resolve, reject) => {
        collectionService.getExamAdditionalQuestions(data)
          .then((response) => {
            commit('set_exam_additional_questions', response.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    getSimulatorAdditionalQuestion({ commit }, params) {
      return new Promise((resolve, reject) => {
        collectionService.getAdditionQuestionsForSimulator(params.examId, params.collectionId, params.questionId)
          .then((response) => {
            commit('set_simulator_additional_questions', response.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    setSimulatorWrongQuestions({ commit }, wrongQuestions) {
      commit('set_simulator_wrong_questions', wrongQuestions);
    },
    clearQuestions({ commit }) {
      commit('clear_questions');
    },
  },
  mutations: {
    set_collections(state, collections) {
      state.collections = collections;
    },
    set_constructors(state, constructors) {
      state.constructors = constructors;
    },
    collections_loading_start(state) {
      state.isLoading.collections = true;
    },
    collections_loading_finish(state) {
      state.isLoading.collections = false;
    },
    set_collection_tickets(state, tickets) {
      state.tickets = tickets;
    },
    tickets_loading_start(state) {
      state.isLoading.tickets = true;
    },
    tickets_loading_finish(state) {
      state.isLoading.tickets = false;
    },
    set_questions(state, questions) {
      state.questions = questions;
    },
    clear_questions(state) {
      state.questions = [];
    },
    questions_loading_start(state) {
      state.isLoading.questions = true;
    },
    questions_loading_finish(state) {
      state.isLoading.questions = false;
    },
    set_exam_additional_questions(state, questions) {
      for (const question of questions) {
        state.questions.push(question);
      }
    },
    set_simulator_additional_questions(state, questions) {
      state.questions.push(...questions);
    },
    set_themes(state, themes) {
      state.themes = themes;
    },
    set_simulator_wrong_questions(state, wrongQuestions) {
      state.simulatorWrongQuestions = wrongQuestions;
    },
    themes_loading_start(state) {
      state.isLoading.themes = true;
    },
    themes_loading_finish(state) {
      state.isLoading.themes = false;
    },
  },
};
